module.exports = __webpack_public_path__ + "img/hiep.aafd0eeb.jpg";